var _path, _path2, _path3, _circle, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocker2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 44C137.669 90.9168 99.4457 112 69.3092 112C39.1727 112 0 86.6592 0 59.6696C0 32.6801 7.19355 15.8734 37.5085 5.46611C67.8235 -4.94119 130.331 -2.91677 134 44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1255 40.85C94.0619 39.1958 94.0619 37.6053 94.0619 36.0784C94.0619 34.8696 93.1076 33.9152 91.8988 33.9152C82.5464 33.8516 75.4208 31.1795 69.504 25.4536C68.6769 24.6265 67.2772 24.6265 66.4501 25.4536C60.5333 31.1795 53.4077 33.8516 44.1189 33.8516C42.9101 33.8516 41.9558 34.8059 41.9558 36.0148C41.9558 37.5417 41.9558 39.1322 41.8922 40.85C41.5741 56.5646 41.1287 78.0051 67.2772 87.0393C67.5317 87.103 67.7226 87.1666 67.977 87.1666C68.2315 87.1666 68.486 87.103 68.6769 87.0393C94.8254 78.0051 94.38 56.5646 94.1255 40.85Z",
    fill: "#E3E2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1252 40.85C94.0616 39.1958 94.0616 37.6053 94.0616 36.0784L47.6617 72.585C51.3963 78.5115 57.464 83.649 67.2769 87.0393C67.5313 87.1029 67.7222 87.1666 67.9767 87.1666C68.2312 87.1666 68.4857 87.1029 68.6765 87.0393C94.825 78.0051 94.3797 56.5645 94.1252 40.85Z",
    fill: "#D2D1FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.0004,
    cy: 68.2239,
    r: 3.50804,
    transform: "rotate(-180 68.0004 68.2239)",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0102 61.3215C66.0727 61.3215 64.5021 59.7509 64.5021 57.8135L64.4821 44.6178C64.4821 42.6804 66.0527 41.1098 67.9901 41.1098C69.9275 41.1098 71.4981 42.6804 71.4981 44.6178L71.5182 57.8135C71.5182 59.7509 69.9476 61.3215 68.0102 61.3215Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocker2);
export default __webpack_public_path__ + "static/media/blocker2.1f5866e3c650ee591d84d94a6055f0c0.svg";
export { ForwardRef as ReactComponent };